import Vue from 'vue';
import moment from 'moment';
import { formatterTimeByHouerAndMinutes } from '@/utils/common';
export function point_one(val: number) {
  return val ? (val / 100).toFixed(1) : 0;
}
export function point_two(val: number) {
  return val ? (val / 100).toFixed(2) : 0;
}
export function percent(val: number) {
  return val ? (val * 100).toFixed(2) + '%' : 0;
}

Vue.filter('time_till_seconds', (seconds: number) => moment(seconds * 1000).format('YYYY-MM-DD HH:mm:ss'));
Vue.filter('rmb', (money: number) => (money / 100).toFixed(2) + ' 元');
Vue.filter(
  'month_duration',
  (obj: { start: number; end: number }) => `${moment(obj.start * 1000).format('MM月DD日')} ~ ${moment(obj.end * 1000).format('MM月DD日')} `
);
// 百分比
Vue.filter('percent', (val: number) => percent(val));
Vue.filter('point_one', (val: number) => point_one(val));
Vue.filter('point_two', (val: number) => point_two(val));
// 百分比， 元， 数量
Vue.filter('hour_minute', (val: number) => formatterTimeByHouerAndMinutes(val, true));
